<section class="infobar-block" [class.infobar-block--expanded]="expandedLayout">
  <div class="infobar-heading">
    <span class="eyebrow">Resources</span>
    <h3>{{ headingText }}</h3>
  </div>

  <div class="infobar-intro-row" *ngIf="expandedLayout">
    <p class="infobar-intro">
      Learn how VISP supports speech research, onboarding, and secure collaboration.
    </p>
    <button type="button" class="infobar-cta-button" (click)="toggleAccessRequestForm()">
      <i class="fa fa-key" aria-hidden="true"></i>
      {{ showAccessRequestForm ? 'Close form' : 'Request access' }}
    </button>
  </div>

  <form
    *ngIf="expandedLayout && showAccessRequestForm"
    class="access-request-form"
    [formGroup]="accessRequestForm"
    (ngSubmit)="submitAccessRequest()"
    novalidate
  >
    <div class="access-form-header">
      <span class="access-form-icon">
        <i class="fa fa-shield" aria-hidden="true"></i>
      </span>
      <div>
        <h4>Request access to VISP</h4>
        <p>Enter your email address and we'll open a prefilled message to our support team.</p>
      </div>
    </div>
    <div class="access-request-field">
      <label for="access-request-email">Your contact email</label>
      <div class="access-request-row">
        <div class="access-input-wrap">
          <i class="fa fa-envelope-o access-input-icon" aria-hidden="true"></i>
          <input
            id="access-request-email"
            type="email"
            formControlName="email"
            placeholder="name@example.org"
            autocomplete="email"
          >
        </div>
        <button type="submit">
          <i class="fa fa-paper-plane-o" aria-hidden="true"></i>
          Send request
        </button>
      </div>
      <p class="access-request-error" *ngIf="accessEmailControl?.touched && accessEmailControl?.invalid">
        Enter a valid e-mail address to continue.
      </p>
    </div>
    <p class="access-request-hint">
      This opens your e-mail client with a prefilled request to support&#64;humlab.umu.se.
    </p>
  </form>

  <div class="infobar-card-grid">
    <app-infobox *ngFor="let infobox of infoboxes" [infobox]="infobox"></app-infobox>
  </div>


</section>
